import api from '@/services/api'

export default class CommitmentAPI {
  static COMMITMENTS_ENDPOINT = 'commitments'
  /**
   * Initialize a `CommitmentAPI` instance.
   *
   * @param {class} cls  The class to use to create commitment objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `CommitmentAPI`.
   *
   * @param {class} cls      The class to use to create commitment objects.
   **/
  static create(cls) {
    return new CommitmentAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Create Commitment via the API.
   *
   * @param {String} commitmentId  Unique ID of the commitment to retrieve.
   */
  create(commitment) {
    const url = `${CommitmentAPI.COMMITMENTS_ENDPOINT}/`
    const data = this.cls.toAPI(commitment)
    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
  }

  /**
   * Retrieve one commitment from the API.
   *
   * @param {String} commitmentId  Unique ID of the commitment to retrieve.
   */
  get(commitmentId) {
    const url = `${CommitmentAPI.COMMITMENTS_ENDPOINT}/${commitmentId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Get all commitment through the API.
   *
   *
   */
  // eslint-disable-next-line no-unused-vars
  list({ filters = {} } = {}) {
    const url = `${CommitmentAPI.COMMITMENTS_ENDPOINT}/`
    const options = {
      params: {},
    }

    if (filters.submitter) {
      options.params.submitter = filters.submitter
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => {
        // To Do, add data.results instead of data when you add pagination
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
  }

  /**
   * Update a commitment through the API.
   *
   * @param {commitment} commitment data to send to the API.
   */
  update(commitment, fields = [], excludeFields = []) {
    const url = `${CommitmentAPI.COMMITMENTS_ENDPOINT}/${commitment.id}/`
    const data = this.cls.toAPI(commitment, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }
}
